import {
  CompStatus,
  TComp,
} from '@chancer/common/lib/interfaces/firestore/FirestoreInterfaces';
import React, {useMemo} from 'react';
import {useRecoilValue} from 'recoil';
import {
  competitionLeaderboardsSubscriptionState,
  competitionsNonDraftQuestionIdsState,
  competitionStatusSubscriptionState,
} from '../../../../recoil/FirestoreRecoil';
import {Badge} from '../../../components/Badge';
import {StatusChip} from '../../../components/Competitions/StatusChip';

interface IProps {
  compId: string;
  comp: TComp;
}

export const CompStatusBadges: React.FC<IProps> = (props) => {
  const compStatus = useRecoilValue(
    competitionStatusSubscriptionState(props.compId),
  );
  const compLeaderboards = useRecoilValue(
    competitionLeaderboardsSubscriptionState(props.compId),
  );
  const showQuestionCounts = useMemo(
    () =>
      !props.comp.template &&
      (compStatus?.status === CompStatus.DRAFT ||
        compStatus?.status === CompStatus.OPEN ||
        compStatus?.status === CompStatus.INPLAY) &&
      compLeaderboards?.some((l) => l.isMiniLeague && l.published),
    [props.comp.template, compStatus?.status, compLeaderboards],
  );
  const nonDraftQuestionCount = useRecoilValue(
    competitionsNonDraftQuestionIdsState(
      showQuestionCounts ? [props.compId] : [],
    ),
  ).length;
  const nonDraftMiniLeagueQuestionCount = useRecoilValue(
    competitionsNonDraftQuestionIdsState(
      showQuestionCounts
        ? Array.from(
            new Set(
              compLeaderboards?.flatMap((l) =>
                l.isMiniLeague && l.published ? l.comps : [],
              ),
            ),
          )
        : [],
    ),
  ).length;

  return (
    <div className="flex gap-x-1">
      {compStatus && (
        <StatusChip
          size="small"
          status={compStatus.status}
          published={props.comp.published}
          template={props.comp.template}
        />
      )}
      {compLeaderboards?.some((l) => l.isMiniLeague && l.published) && (
        <Badge
          label={`MINI LEAGUE${showQuestionCounts ? ` (${nonDraftQuestionCount}/${nonDraftMiniLeagueQuestionCount})` : ''}`}
          color="#FFFFFF"
          backgroundColor="#9333ea"
        />
      )}
    </div>
  );
};
